import React from 'react';
import AdminDocument from '../../features/legal/AdminDocument';
export default function PrivacyPolicyAdmin() {
  return <AdminDocument type="privacy" />;
}
